import { useState } from "react";
import { Link } from "@tanstack/react-router";
import { Menu, X } from "lucide-react";
import logoFeo from "@/assets/feo/logo-feo.png";
import { BlackTopBar } from "@/components/black2x1/BlackTopBar";
import { useSiteLink } from "@/lib/managed-links/use-site-link";

export function SiteHeader() {
  const [open, setOpen] = useState(false);

  const certUrl = useSiteLink("link.header.certificacao", "/certificacao");
  const starUrl = useSiteLink("link.header.star", "/star");
  const livroUrl = useSiteLink(
    "link.header.livro",
    "https://www.manole.com.br/fisioterapia-na-reabilitacao-musculoesqueletica/p",
  );
  const efisioUrl = useSiteLink("link.header.efisio", "/e-fisio");
  const loginUrl = useSiteLink("link.header.login", "https://feo.alpaclass.com/logar");

  const NAV = [
    { label: "Quem Somos", to: "/quem-somos", type: "route" as const },
    { label: "Pós-graduações", to: "/pos", type: "route" as const },
    {
      label: "Certificações",
      to: certUrl,
      type: certUrl.startsWith("/") ? ("route" as const) : ("external" as const),
    },
    { label: "Star Cursos", to: starUrl, type: starUrl.startsWith("/") ? ("route" as const) : ("external" as const) },
    { label: "Livro", to: livroUrl, type: "external" as const },
    {
      label: "E-Fisio",
      to: efisioUrl,
      type: efisioUrl.startsWith("/") ? ("route" as const) : ("external" as const),
    },
  ];

  return (
    <header className="sticky top-0 z-50 w-full bg-[#13123a] border-b border-white/5">
      <BlackTopBar origem="site" />
      <div className="container mx-auto flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4">
        <Link to="/" className="flex items-center shrink-0" aria-label="Fisio em Ortopedia">
          <img decoding="async" src={logoFeo} alt="Fisio em Ortopedia" className="h-9 sm:h-11 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-5 xl:gap-8">
          {NAV.map((item) =>
            item.type === "route" ? (
              <Link
                key={item.label}
                to={item.to}
                className="text-white/90 hover:text-[var(--primary)] font-semibold text-[15px] transition-colors"
                activeProps={{ className: "text-[var(--primary)]" }}
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={item.label}
                href={item.to}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/90 hover:text-[var(--primary)] font-semibold text-[15px] transition-colors"
              >
                {item.label}
              </a>
            ),
          )}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={loginUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center rounded-full bg-[var(--brand-ink)] hover:brightness-110 text-[#13123a] font-bold px-5 py-2 text-xs sm:px-8 sm:py-2.5 sm:text-sm tracking-wide transition-all"
          >
            LOGIN
          </a>

          <button
            aria-label="Abrir menu"
            className="lg:hidden text-white p-2"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>


      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#13123a]">
          <nav className="container mx-auto flex flex-col gap-1 px-4 py-4">
            {NAV.map((item) =>
              item.type === "route" ? (
                <Link
                  key={item.label}
                  to={item.to}
                  onClick={() => setOpen(false)}
                  className="text-white/90 hover:text-[var(--primary)] font-semibold py-3 px-2"
                >
                  {item.label}
                </Link>
              ) : (
                <a
                  key={item.label}
                  href={item.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/90 hover:text-[var(--primary)] font-semibold py-3 px-2"
                >
                  {item.label}
                </a>
              ),
            )}
          </nav>
        </div>
      )}
    </header>
  );
}
